import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import {
  IonButton,
  IonCard,
  IonCol,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonPopover,
  IonRadio,
  IonRadioGroup,
  IonRow,
  IonText,
  IonTextarea,
} from '@ionic/angular/standalone';
import { NgSelectModule } from '@ng-select/ng-select';
import { AdminRoutingModule } from '../admin/admin.routing.module';
import { SharedModule } from '../shared/shared.module';
import { HeaderSearchComponent } from '../shared/table/components/table-header/header-search/header-search.component';
import { OperationsRoutingModule } from './operations.routing.module';
import { PickupAssignmentComponent } from './pickup-assignment/pickup-assignment.component';
import { AddressSectionComponent } from './pickup-assignment/pickup/on-demand-pickup/address-section/address-section.component';
import { CurrentPickupSectionComponent } from './pickup-assignment/pickup/on-demand-pickup/current-pickup-section/current-pickup-section.component';
import { NotesSectionComponent } from './pickup-assignment/pickup/on-demand-pickup/notes-section/notes-section.component';
import { OnDemandPickupComponent } from './pickup-assignment/pickup/on-demand-pickup/on-demand-pickup.component';
import { SchedulingSectionComponent } from './pickup-assignment/pickup/on-demand-pickup/scheduling-section/scheduling-section.component';
import { PickupComponent } from './pickup-assignment/pickup/pickup.component';
import { ScheduledPickupComponent } from './pickup-assignment/pickup/scheduled-pickup/scheduled-pickup.component';
import { AddDeliveryStopComponent } from './route-summary/route-details/add-operations-stop/add-delivery-stop/add-delivery-stop.component';
import { AddOperationsStopComponent } from './route-summary/route-details/add-operations-stop/add-operations-stop.component';
import { NewPackageDetailsComponent } from './route-summary/route-details/add-operations-stop/new-package-details/new-package-details.component';
import { DetailsComponent } from './route-summary/route-details/details/details.component';
import { EditOperationsStopComponent } from './route-summary/route-details/edit-operations-stop/edit-operations-stop.component';
import { EditStopLeftSectionComponent } from './route-summary/route-details/edit-operations-stop/edit-stop-left-section/edit-stop-left-section.component';
import { PendingStopsComponent } from './route-summary/route-details/pending-stops/pending-stops.component';
import { RouteDetailsComponent } from './route-summary/route-details/route-details.component';
import { RouteSummaryComponent } from './route-summary/route-summary.component';
import { SummaryComponent } from './route-summary/summary/summary.component';
import { AddPickupRequestComponent } from './shared/add-pickup-request/add-pickup-request.component';
import { DaysAssignedComponent } from './shared/days-assigned/days-assigned.component';
import { DeleteFileConfirmationPopupComponent } from './shared/delete-file-confirmation-popup/delete-file-confirmation-popup.component';
import { DndDirective } from './shared/dnd.directive';
import { FileUploadComponent } from './shared/file-upload/file-upload.component';
import { OperationsHeaderComponent } from './shared/operations-header/operations-header.component';
import { PickupPopupComponent } from './shared/pickup-popup/pickup-popup.component';
import { ProgressBarComponent } from './shared/progress-bar/progress-bar.component';
import { RouteStatusComponent } from './shared/route-status/route-status.component';
import { SummaryDashboardComponent } from './shared/summary-dashboard/summary-dashboard.component';
import { AddressBookComponent } from './route-summary/route-details/add-operations-stop/address-book/address-book.component';

@NgModule({
  declarations: [
    RouteSummaryComponent,
    PickupAssignmentComponent,
    OperationsHeaderComponent,
    SummaryComponent,
    SummaryDashboardComponent,
    PickupComponent,
    RouteStatusComponent,
    RouteDetailsComponent,
    AddOperationsStopComponent,
    EditOperationsStopComponent,
    FileUploadComponent,
    DndDirective,
    ProgressBarComponent,
    DeleteFileConfirmationPopupComponent,
    DetailsComponent,
    EditStopLeftSectionComponent,
    PendingStopsComponent,
    ScheduledPickupComponent,
    OnDemandPickupComponent,
    SchedulingSectionComponent,
    CurrentPickupSectionComponent,
    AddressSectionComponent,
    NotesSectionComponent,
    PickupPopupComponent,
    AddPickupRequestComponent,
    DaysAssignedComponent,
    AddDeliveryStopComponent,
    NewPackageDetailsComponent,
    AddressBookComponent,
  ],
  exports: [SummaryDashboardComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    MatPaginatorModule,
    CommonModule,
    OperationsRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    HeaderSearchComponent,
    IonRow,
    IonCol,
    IonTextarea,
    IonButton,
    IonCard,
    IonInput,
    IonRadioGroup,
    IonItem,
    IonRadio,
    IonLabel,
    IonList,
    IonIcon,
    IonText,
    IonPopover,
    MatSortModule,
    MatTableModule,
    MatCheckboxModule,
    AdminRoutingModule,
    MatIconModule,
    MatSelectModule,
    NgSelectModule,
    MatTooltip,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class OperationsModule {}
